import React from 'react';
import { AdminShell } from './v2/AdminShell';
import { AccountsState, Account } from '../../types/accounts';
import { AppState, ModuleId, Question } from '../../types';
interface AdminOverviewPageProps {
  accounts: AccountsState;
  getLearnerData: (learnerId: string) => AppState | null;
  getLearnerModuleMastery: (learnerId: string, moduleId: ModuleId) => number;
  selectedGroup: number;
  onNavigate?: (view: string) => void;
  onNavigateToLearner?: (learnerId: string) => void;
  allAccounts?: Account[];
  activeAccountId?: string;
  onSwitchAccount?: (accountId: string) => void;
  onLogout?: () => void;
  questions?: Question[];
  state?: AppState;
  onReturnHome?: () => void;
}
export function AdminOverviewPage({
  accounts,
  getLearnerData,
  getLearnerModuleMastery,
  selectedGroup,
  onNavigate,
  onNavigateToLearner,
  allAccounts,
  activeAccountId,
  onSwitchAccount,
  onLogout,
  questions,
  state,
  onReturnHome
}: AdminOverviewPageProps) {
  return <AdminShell accounts={accounts} getLearnerData={getLearnerData} getLearnerModuleMastery={getLearnerModuleMastery} selectedGroup={selectedGroup} onNavigate={onNavigate} onNavigateToLearner={onNavigateToLearner} allAccounts={allAccounts} activeAccountId={activeAccountId} onSwitchAccount={onSwitchAccount} onLogout={onLogout} questions={questions} state={state} onReturnHome={onReturnHome} data-id="element-42" />;
}